import axios from 'axios'
import queryString from 'query-string'
import omitBy from 'lodash/omitBy'

import ssoRequest from '../../../../common/utils/ssoRequest'
import config from '../../../../common/config'

const ssoHost = config.sso.SERVER_HOST

export const handleSubmit = (data, {
  handleSignInSuccess,
  handleSignInError,
  handlePassword,
  handleCaptcha,
  handle2FA,
  handleSignInVerification,
  handlePasswordReset,
  handleEmailConfirmation
}) => {
  // remove empty form field
  const formData = omitBy(data, value => !value)
  const payload = queryString.stringify(formData)

  ssoRequest.post(
    `${ssoHost}/sign_in`,
    payload,
    { withCredentials: true }
  ).then(response => {
    const { data } = response
    if (data && data.state) {
      switch (data.state) {
        case 'ok':
          const token = data.token
          axios.post('/jwt_session', {
            token
          }).then(response => {
            const { token } = response.data
            handleSignInSuccess(token)
          }).catch(err => {
            handleSignInError(err)
          })
          break
        case 'password':
          handlePassword(data)
          break
        case 'captcha':
          handleCaptcha(data)
          break
        case 'two_factor':
          handle2FA(data)
          break
        case 'sign_in_verification':
          handleSignInVerification(data)
          break
        case 'password_reset_required':
          handlePasswordReset(data)
          break
        case 'email_confirmation_required':
          handleEmailConfirmation(data)
          break
      }
    }
  }).catch(error => {
    handleSignInError(error)
  })
}

export const autoSignIn = (payload, {
  handleAutoSignInSuccess,
  handleAutoSignInError
}) => {
  const data = queryString.stringify(payload)
  ssoRequest.post(`${ssoHost}/api/auto_sign_in`, data, {
    withCredentials: true
  }).then(response => {
    const { token } = response.data
    axios.post('/jwt_session', {
      token
    }).then(response => {
      const { token } = response.data
      handleAutoSignInSuccess(token)
    }).catch(err => {
      handleAutoSignInError(err)
    })
  })
}



// WEBPACK FOOTER //
// ./client/components/modals/user/signInHelper.js